import React from "react";
import { googleIcon } from "../assets/images";
import { FaApple } from "react-icons/fa";
import { API } from "../constants/api";

const Oauth = () => {
  return (
    <div className="w-full ">
      <div className="w-full h-full flex justify-center gap-4 items-center">
        <a
          href={`${API.initiateLogin("google")}`}
          className="w-1/2 h-[48px] flex justify-center items-center border border-gray-300 dark:border-gray-700 rounded-lg"
        >
          <div className="w-[24px] h-[24px] flex justify-center items-center">
            <img
              src={googleIcon}
              alt="google"
              className="w-full h-full object-cover"
            />
          </div>
        </a>
        <a
          href={`${API.initiateLogin("apple")}`}
          className="w-1/2 h-[48px] flex justify-center items-center border border-gray-300 dark:border-gray-700 rounded-lg"
        >
          <FaApple className="text-[24px] text-gray-900 dark:text-gray-100 " />
        </a>
      </div>
      <div className="w-full mt-6 flex gap-4 justify-center items-center">
        <div className="w-full h-[1px] bg-gray-300 dark:bg-gray-700 rounded-full" />
        <span className="text-gray-600 dark:text-gray-400 text-[14px] font-medium">
          OR
        </span>
        <div className="w-full h-[1px] bg-gray-300 dark:bg-gray-700 rounded-full" />
      </div>
    </div>
  );
};

export default Oauth;
